module.exports = __webpack_public_path__ + "static/person-78bd4a1961430d463a117511ac92bc05.svg";